import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ProxyInfo, WebsocketConnection } from "../common.browser/Exports";
import { ForceDictationPropertyName, OutputFormatPropertyName } from "../common.speech/Exports";
import { OutputFormat, PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { RecognitionMode, WebsocketMessageFormatter } from "./Exports";
import { QueryParameterNames } from "./QueryParameterNames";
export var SpeechConnectionFactory = /*#__PURE__*/function (_ConnectionFactoryBas) {
  _inherits(SpeechConnectionFactory, _ConnectionFactoryBas);

  var _super = _createSuper(SpeechConnectionFactory);

  function SpeechConnectionFactory() {
    var _this;

    _classCallCheck(this, SpeechConnectionFactory);

    _this = _super.apply(this, arguments);
    _this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1";
    _this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1";
    _this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1";

    _this.create = function (config, authInfo, connectionId) {
      var endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint, undefined);
      var queryParams = {};
      var endpointId = config.parameters.getProperty(PropertyId.SpeechServiceConnection_EndpointId, undefined);
      var language = config.parameters.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage, undefined);

      if (endpointId) {
        if (!endpoint || endpoint.search(QueryParameterNames.DeploymentIdParamName) === -1) {
          queryParams[QueryParameterNames.DeploymentIdParamName] = endpointId;
        }
      } else if (language) {
        if (!endpoint || endpoint.search(QueryParameterNames.LanguageParamName) === -1) {
          queryParams[QueryParameterNames.LanguageParamName] = language;
        }
      }

      if (!endpoint || endpoint.search(QueryParameterNames.FormatParamName) === -1) {
        queryParams[QueryParameterNames.FormatParamName] = config.parameters.getProperty(OutputFormatPropertyName, OutputFormat[OutputFormat.Simple]).toLowerCase();
      }

      _this.setCommonUrlParams(config, queryParams, endpoint);

      if (!endpoint) {
        var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Region, undefined);
        var host = "wss://" + region + ".stt.speech.microsoft.com";

        switch (config.recognitionMode) {
          case RecognitionMode.Conversation:
            if (config.parameters.getProperty(ForceDictationPropertyName, "false") === "true") {
              endpoint = host + _this.dictationRelativeUri;
            } else {
              endpoint = host + _this.conversationRelativeUri;
            }

            break;

          case RecognitionMode.Dictation:
            endpoint = host + _this.dictationRelativeUri;
            break;

          default:
            endpoint = host + _this.interactiveRelativeUri; // default is interactive

            break;
        }
      }

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[QueryParameterNames.ConnectionIdHeader] = connectionId;
      return new WebsocketConnection(endpoint, queryParams, headers, new WebsocketMessageFormatter(), ProxyInfo.fromRecognizerConfig(config), connectionId);
    };

    return _this;
  }

  return SpeechConnectionFactory;
}(ConnectionFactoryBase);